import { ReservoirCreate, ReservoirDetail, ReservoirDetailWithProduction, ReservoirInfo, ReservoirPropertiesUpdate, ReservoirUpdate } from '@/types/layer';
import { filterVisibleLayerAttributes } from '@/data/hiddenLayerAttributes';
import { apiClient } from './client';

export const reservoirsApi = {
  // Get reservoirs from user's visible fields (optionally scoped to one field)
  getOrganizationReservoirs: async (fieldId?: string): Promise<ReservoirInfo[]> => {
    const url = fieldId
      ? `/layers/?field_id=${encodeURIComponent(fieldId)}`
      : '/layers/';
    const response = await apiClient.get<ReservoirInfo[]>(url);
    return response;
  },

  // Get reservoir details with all properties
  getReservoir: async (reservoirId: string): Promise<ReservoirDetailWithProduction> => {
    console.log('Fetching reservoir:', reservoirId);
    const response = await apiClient.get<ReservoirDetailWithProduction>(`/layers/${reservoirId}`);
    console.log('Reservoir response:', response);
    return response;
  },

  // Create new reservoir
  createReservoir: async (reservoirData: ReservoirCreate): Promise<ReservoirDetail> => {
    const response = await apiClient.post<ReservoirDetail>('/layers/', reservoirData);
    return response;
  },

  // Update reservoir basic info
  updateReservoir: async (reservoirId: string, reservoirData: ReservoirUpdate): Promise<ReservoirDetail> => {
    console.log('API: updateReservoir called with:', { reservoirId, reservoirData });
    const response = await apiClient.put<ReservoirDetail>(`/layers/${reservoirId}`, reservoirData);
    console.log('API: updateReservoir response:', response);
    return response;
  },

  // Update reservoir properties
  updateReservoirProperties: async (reservoirId: string, propertiesData: ReservoirPropertiesUpdate): Promise<ReservoirDetail> => {
    console.log('API: updateReservoirProperties called with:', { reservoirId, propertiesData });
    const response = await apiClient.put<ReservoirDetail>(`/layers/${reservoirId}/properties`, propertiesData);
    console.log('API: updateReservoirProperties response:', response);
    return response;
  },

  // Get all reservoir attributes (UI-visible only)
  getReservoirAttributes: async (): Promise<Array<{id: string; name: string; unit?: string | null; type: string; description: string | null}>> => {
    const response = await apiClient.get<Array<{id: string; name: string; unit?: string | null; type: string; description: string | null}>>('/layers/attributes');
    return filterVisibleLayerAttributes(response, (a) => a.id, (a) => a.name);
  },

  deleteReservoir: async (reservoirId: string): Promise<void> => {
    await apiClient.delete(`/layers/${reservoirId}`);
  },

  importLayerProduction: async (
    layerId: string,
    rows: Array<{ year: number; oil: number | null; gas: number | null; water: number | null }>,
  ): Promise<import('@/types/layer').ReservoirProductionData[]> => {
    return apiClient.put(`/layers/${layerId}/production/import`, { rows });
  },

};

// Convenience exports
export const { getOrganizationReservoirs, getReservoir, createReservoir, updateReservoir, updateReservoirProperties, getReservoirAttributes, deleteReservoir } = reservoirsApi;

// Legacy aliases for backward compatibility
export const layersApi = {
  ...reservoirsApi,
  getLayer: reservoirsApi.getReservoir,
  createLayer: reservoirsApi.createReservoir,
  updateLayer: reservoirsApi.updateReservoir,
  updateLayerProperties: reservoirsApi.updateReservoirProperties,
  getLayerAttributes: reservoirsApi.getReservoirAttributes,
  deleteLayer: reservoirsApi.deleteReservoir,
  getOrganizationLayers: reservoirsApi.getOrganizationReservoirs,
};
export const { getOrganizationLayers, getLayer, createLayer, updateLayer, updateLayerProperties, getLayerAttributes, deleteLayer, importLayerProduction } = layersApi;
